// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/vfr-navigation-emergency-assistance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/vfr-navigation-emergency-assistance/vfr-navigation-emergency-assistance.js';

mount([g0]);
